import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Platform } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/fromPromise";
import "rxjs/add/operator/mergeMap";
import { take, tap } from "rxjs/operators";
import { Api } from "./../api/api";
/*
  Generated class for the WebPushProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WebPushProvider {
  _window: any;

  constructor(
    public http: HttpClient,
    public api: Api,
    public platform: Platform
  ) {}


  initialiseState() {
    this._window = window;

    // this.unsubscribe();

    if (!("showNotification" in ServiceWorkerRegistration.prototype)) {
      console.warn("Notifications aren't supported.");
      return;
    }

    if (this._window.Notification.permission === "denied") {
      console.warn("The user has blocked notifications.");
      return;
    }

    if (!("PushManager" in window)) {
      console.warn("Push messaging isn't supported.");
      return;
    }

    Notification.requestPermission((result) => {
      if (result === "granted") {
        // this.subscribe();
      }
    });
  }

  subscribe(): void {
    let _window: any;
    _window = window;

    // const publicKey = this.urlB64ToUint8Array(
    //   "BDjF1XYkXdZ7Fe53yr5CqbPVJjtG3lM8sOnYDSZ-pB25FhQn1cmmAFaZe5ZH25lCvZgnVrK2JDFYb5QiQhd8qOM="
    // );

    const publicKey =
      "BLpdYhPKHUeWHKlAMHIESOYF-ExLnjmRgilS0fKC6SUIcYVS_z6tJKFh4IRLXzOdFmnfQ437SPzn2OfpLw5fK9Q";

    // this.swPush
    //   .requestSubscription({
    //     serverPublicKey: publicKey,
    //   })
    //   .then((subscription) => this.sendSubscriptionToServer(subscription))
    //   .catch((e) =>
    //     _window.Notification.permission === "denied"
    //       ? console.warn("Permission for Notifications was denied")
    //       : console.error("Unable to subscribe to push.", e)
    //   );
  }

  doItNow(): void {}

  sendSubscriptionToServer(subscription) {
    const key = subscription.getKey ? subscription.getKey("p256dh") : "";

    const auth = subscription.getKey ? subscription.getKey("auth") : "";

    const endpoint = subscription.endpoint.replace(
      "https://fcm.googleapis.com/fcm/send/",
      "https://fcm.googleapis.com/v1/projects/matchabout-e39a6/messages:send/"
    );

    const p256dh = key
      ? btoa(String.fromCharCode.apply(null, new Uint8Array(key)))
      : "";

    const authorization = auth
      ? btoa(String.fromCharCode.apply(null, new Uint8Array(auth)))
      : "";

    this.subscribeToPush(endpoint, p256dh, authorization).subscribe();
  }

  urlB64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);

    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  }

  unsubscribe(): void {
    // this.swPush.subscription
    //   .pipe(
    //     take(1),
    //     tap((sub) =>
    //       sub
    //         ? sub.unsubscribe().then(() => {
    //             console.log("Unsubscribed from notifications");
    //             this.subscribe();
    //           })
    //         : console.log("No subscription to unsubscribe")
    //     )
    //   )
    //   .subscribe();
  }

  unsubscribeFromPush(
    endpoint: string,
    p256dh: string,
    auth: string
  ): Observable<any> {
    return this.api
      .post("webpush/unsubscribe", {
        endpoint,
        p256dh,
        auth,
      })
      .map((res) => res);
  }

  subscribeToPush(
    endpoint: string,
    p256dh: string,
    auth: string
  ): Observable<any> {
    return this.api
      .post("webpush/subscribe", {
        endpoint,
        p256dh,
        auth,
      })
      .map((res) => res);
  }
}



// WEBPACK FOOTER //
// ./src/providers/web-push/web-push.ts